import React from 'react';
import PropTypes from 'prop-types';
import { Line, Bar, Pie, Doughnut } from 'react-chartjs-2';
import { Panel } from 'react-bootstrap';
import * as annotationPlugin from 'chartjs-plugin-annotation';
import ConditionalComponent from './ConditionalComponent';

const chartMap = type => {
  switch (type) {
    case 'line':
      return Line;
    case 'bar':
      return Bar;
    case 'pie':
      return Pie;
    case 'doughnut':
      return Doughnut;
    default:
      return null;
  }
};

const ChartComponent = ({
  type,
  data,
  options,
  width,
  height,
  lines,
  panelOptions,
  onClick
}) => {
  const Component = chartMap(type);
  if (!Component) {
    return null;
  }

  let completeOptions = {
    ...options,
    onClick: (evt, ai) => {
      if (!onClick || !ai || !ai[0]) {
        return;
      }
      onClick(ai[0]);
    }
  };
  if (lines) {
    const annotations = lines.map(l => ({
      type: 'line',
      drawTime: 'afterDatasetsDraw',
      mode: 'vertical',
      scaleID: 'x-axis-0',
      value: l.xAxisValue,
      borderColor: l.color,
      borderWidth: 2
    }));
    completeOptions = {
      ...completeOptions,
      annotation: { annotations }
    };
  }

  const theChart = (
    <Component
      id="chart-component"
      plugins={[annotationPlugin]}
      data={data}
      options={completeOptions}
      width={width}
      height={height}
    />
  );

  const chartInPanel = panelOptions && (
    <Panel bsStyle={panelOptions.bsStyle}>
      {panelOptions.title &&
        <Panel.Heading>
          <Panel.Title>
            {panelOptions.title}
          </Panel.Title>
        </Panel.Heading>
      }
      <Panel.Body>
        {theChart}
      </Panel.Body>
      {panelOptions.footer &&
        <Panel.Footer>
          {panelOptions.footer}
        </Panel.Footer>
      }
    </Panel>
  );

  return (
    <ConditionalComponent
      condition={!panelOptions}
      children={theChart}
      elseChildren={chartInPanel}
    />
  );
};

ChartComponent.propTypes = {
  type: PropTypes.oneOf(['pie', 'line', 'bar', 'doughnut']).isRequired,
  data: PropTypes.object.isRequired,
  options: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
  lines: PropTypes.arrayOf(PropTypes.shape({
    xAxisValue: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired
  })),
  panelOptions: PropTypes.shape({
    title: PropTypes.any,
    footer: PropTypes.any,
    bsStyle: PropTypes.string
  }),
  onClick: PropTypes.func
};

ChartComponent.defaultProps = { height: 180 };

export default ChartComponent;


// WEBPACK FOOTER //
// src/Components/ChartComponent.jsx